import { createSelector } from 'reselect'
import activeAwardByLevel from 'helpers/activeAwardByLevel'
import { get } from 'lodash'

const participants = (fields, opts) => ({ fields, opts })

const mapForDropdown = ({ fields, opts = {} } = {}) => {
  let inputFields = fields

  try {
    if (opts.awardLevelValue) {
      inputFields = inputFields.filter(participant => {
        const activeIndex = get(participant, 'awards.length', 0) > 1
          ? activeAwardByLevel(participant, opts.awardLevelValue)
          : 0

        return (
          get(participant, `awards[${activeIndex}].awardLevel.value`) ===
          opts.awardLevelValue
        )
      })
    }
  } catch (error) {
    console.log('err', error)
  }

  return inputFields.map(item => ({
    label: `${get(item, 'firstName')} ${get(item, 'lastName')} <${get(item, 'email')}>`,
    value: item.id
  }))
}

export default createSelector(participants, mapForDropdown)
